import window from 'window-or-global';

export function requestAccessWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.confluence-request-access-plugin:confluence-request-access-plugin-resources',
	];
}

export function requestAccess() {
	const grantAccess = window.require('confluence-request-access-plugin/grant-access');
	grantAccess.initWhenEditorReady();
}
